import Filter from '@components/Filter';
import { itemBadges } from '@constants/itemBadges';
import { useAtom } from 'jotai';
import { Dispatch, SetStateAction } from 'react';

import { itemFilterAtom } from '../../../../../atoms/itemFilterAtoms';

interface Props {
  columns: number;
  setColumns: Dispatch<SetStateAction<number>>;
}

function ItemFilters({ columns, setColumns }:Props) {
  const [filters, setFilters] = useAtom(itemFilterAtom);
  const options = ['품절상품 제외']
    .map((it) => ({ value: it, label: it }));
  return (
      <Filter title='보기 설정'
              sort={`${columns}`}
              setSort={(v) => setColumns(Number(v))}
              sortItems={[{ value: '2', label: '2열 보기' }, { value: '3', label: '3열 보기' }]}
              filters={filters}
              setFilters={setFilters}
              filterItems={options} />
  );
}

export default ItemFilters;
